import { type ReactNode, useCallback, useEffect, useRef } from 'react';

type ClickAwayListenerProps = {
  onClickAway: () => void;
  children: ReactNode;
};

export const ClickAwayListener = ({ onClickAway, children }: ClickAwayListenerProps) => {
  const nodeRef = useRef<HTMLDivElement>(null);

  const handleClickAway = useCallback(
    (event: MouseEvent | TouchEvent) => {
      if (nodeRef.current && !nodeRef.current.contains(event.target as Node)) {
        onClickAway();
      }
    },
    [onClickAway],
  );

  useEffect(() => {
    document.addEventListener('mousedown', handleClickAway);
    document.addEventListener('touchstart', handleClickAway);
    return () => {
      document.removeEventListener('mousedown', handleClickAway);
      document.removeEventListener('touchstart', handleClickAway);
    };
  }, [handleClickAway]);

  return <div ref={nodeRef}>{children}</div>;
};
